module.exports = __webpack_public_path__ + "img/animated.27320c47.gif";